import React, { createContext, useContext, useEffect, useState } from "react";
import instance from "../services/instance";
import {
    clearStoredAdminAccessMode,
    getStoredAccessToken,
    getStoredAdminAccessMode,
    setStoredAdminAccessMode,
    setStoredAuthData
} from "../utils/authStorage";
import { resolveSubdomain } from "../utils/subdomain";

const AuthContext = createContext({})
AuthContext.displayName = 'AuthContext'

const extractVerifiedUser = (payload) => {
    const candidates = [
        payload,
        payload?.data,
        payload?.user,
        payload?.data?.user
    ]

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object') {
            continue
        }

        const value = candidate.verifiedUser

        if (typeof value === 'boolean') {
            return value
        }

        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase()
            if (normalized === 'true') {
                return true
            }

            if (normalized === 'false') {
                return false
            }
        }
    }

    return null
}

const extractIsAdmin = (payload) => {
    const candidates = [
        payload,
        payload?.data,
        payload?.user,
        payload?.data?.user
    ]

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object') {
            continue
        }

        const value = candidate.isAdmin

        if (typeof value === 'boolean') {
            return value
        }

        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase()
            if (normalized === 'true') {
                return true
            }

            if (normalized === 'false') {
                return false
            }
        }
    }

    return false
}

const getTokenOrThrow = () => {
    const tokenFromStorage = getStoredAccessToken() || sessionStorage.getItem('@Token:BetBuilder')

    const token = tokenFromStorage
        ? tokenFromStorage.replace(/^Bearer\s+/i, '').replace(/^"|"$/g, '').trim()
        : ''

    if (!token || token === 'undefined' || token === 'null') {
        throw new Error('Token nao encontrado para autenticar requisicao')
    }

    return token
}

const extractAccessToken = (payload) => {
    const candidates = [
        payload,
        payload?.data,
        payload?.user,
        payload?.data?.user
    ]

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object') {
            continue
        }

        const tokenCandidate =
            candidate.token ||
            candidate.accessToken ||
            candidate.authToken

        if (typeof tokenCandidate === 'string' && tokenCandidate.trim()) {
            return tokenCandidate.trim()
        }
    }

    return ''
}

const AuthProvider = ({ children }) => {
    const [authStatus, setAuthStatus] = useState(false)
    const [statusWizard, setStatusWizard] = useState()
    const [verifiedUser, setVerifiedUser] = useState(null)
    const [isAdmin, setIsAdmin] = useState(false)
    const [adminAccessMode, setAdminAccessModeState] = useState(() => getStoredAdminAccessMode())

    const [newToken, setNewToken] = useState()
    

    useEffect(()=>{
        VerifAuth()
    }, [])

    
    const VerifAuth = async() => {
        const hasToken = getStoredAccessToken() || sessionStorage.getItem('@Token:BetBuilder')

        if(hasToken){
            try {
                const response = await GetMe()
                const verified = extractVerifiedUser(response?.data)
                const admin = extractIsAdmin(response?.data)
                setVerifiedUser(verified)
                setIsAdmin(admin)

                if (!admin) {
                    setAdminAccessModeState(null)
                    clearStoredAdminAccessMode()
                }

                setAuthStatus(true)
            } catch (error) {
                setAuthStatus(false)
                setVerifiedUser(null)
                setIsAdmin(false)
                setAdminAccessModeState(null)
                clearStoredAdminAccessMode()
            }
        } else {
            setAuthStatus(false)
            setVerifiedUser(null)
            setIsAdmin(false)
            setAdminAccessModeState(null)
            clearStoredAdminAccessMode()
        }
    }

  
    const Login = async (userData) => {
        try {
            const response = await instance.post(`/v1/auth/login`, userData, {
                params: {
                    subdomain: resolveSubdomain()
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const token = extractAccessToken(response?.data)

            if (!token) {
                throw new Error('Token de acesso nao retornado pelo login.')
            }

            sessionStorage.setItem(`@Token:BetBuilder`, token)
            setStoredAuthData(response?.data, token)

            const profile = response?.data?.data || response?.data || {}
            localStorage.setItem(`@Email:BetBuilder`, profile?.email || '')
            localStorage.setItem(`@Nome:BetBuilder`, profile?.nome || profile?.name || '')
            localStorage.setItem(`@Telefone:BetBuilder`, profile?.telefone || profile?.phone || '')

            const verified = extractVerifiedUser(response?.data)
            const admin = extractIsAdmin(response?.data)
            setVerifiedUser(verified)
            setIsAdmin(admin)

            if (!admin) {
                setAdminAccessModeState(null)
                clearStoredAdminAccessMode()
            }

            // await LoginConta({
            //     username: userData.email,
            //     password: userData.senha
            // })
            
            
            

            
            return response
        } catch(error){
            //console.log('Erro no AuthContext: ', error)
            throw error
        }
    }

    

    const UpdateWizardBool = async () => {
        try {
            const response = await instance.post(`/Perfil/UpdateWizard?email=${localStorage.getItem('@Email:BetBuilder')}&ClienteId=${localStorage.getItem('@ClientId:BetBuilder')}`)
            //console.log(response, " : updateWizardBool")
            return response
        } catch (err) {
            throw err
        }
    }

    const Register = async (userData) => {
        try {
            const response = await instance.post(`/v1/auth/register`, userData, {
                params: {
                    subdomain: resolveSubdomain()
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            return response
        } catch (error) {
            //console.log(error.response.data.message)
            //console.log('Erro no AuthContext: ', error)
            throw error
        }
    }

    const GetInfoPerfil = async (email, clienteId) => {
        try {
            const response = await instance.get(`/Perfil/GetInfoUsuario?email=${email}&clienteId=${clienteId}`)

            return response
        } catch(err) {
            //console.log('Erro ao carregar as informações de usuario no useAuth: ', err)
            throw err
        }
    }

    const UpdateCodigoAfiliado = async (codigo) => {
        try {
            const response = await instance.post(`/Inicio/AtualizarCodigoAfiliado`, {
                codigo: codigo,
                clienteId: localStorage.getItem('@ClientId:BetBuilder'),
                email: localStorage.getItem('@Email:BetBuilder')
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            return response
        } catch (err) {
            //console.log('Erro ao atualizar o codigo do afiliado: ', err)
            throw err.response.data
        }
    }

    const AtualizarToken = async (token, username, clienteId) => {
        try {
            const response = await instance.post(`/Inicio/AtualizarToken?username=${username}&clienteId=${clienteId}&token=${token}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            return response
        } catch (err) {
            //console.log('Erro ao atualizar o codigo do afiliado: ', err)
            throw err.response.data
        }
    }

    const GetMe = async () => {
        const token = getTokenOrThrow()

        try {
            const response = await instance.get('/v1/auth/me', {
                headers: {
                    accept: '*/*',
                    Authorization: `Bearer ${token}`
                }
            })

            return response
        } catch (err) {
            throw err
        }
    }

    const RequestVerification = async (imageFile) => {
        const token = getTokenOrThrow()

        const formData = new FormData()
        formData.append('Image', imageFile)

        try {
            const response = await instance.post('/v1/auth/verification-request', formData, {
                headers: {
                    accept: '*/*',
                    Authorization: `Bearer ${token}`
                }
            })

            return response
        } catch (err) {
            throw err
        }
    }

    const SetAdminAccessMode = (mode) => {
        const saved = setStoredAdminAccessMode(mode)
        setAdminAccessModeState(saved)
        return saved
    }

    const ClearAdminAccessMode = () => {
        clearStoredAdminAccessMode()
        setAdminAccessModeState(null)
    }

    const GetPendingVerificationRequests = async (affiliateId, options = {}) => {
        const token = getTokenOrThrow()

        const {
            page = 1,
            pageSize = 10,
            search = ''
        } = options

        const response = await instance.get('/v1/auth/admin/verification-requests/pending', {
            params: {
                affiliateId,
                page,
                pageSize,
                search,
                subdomain: resolveSubdomain()
            },
            headers: {
                accept: '*/*',
                Authorization: `Bearer ${token}`
            }
        })

        return response
    }

    const GetVerificationRequests = async (affiliateId, options = {}) => {
        const token = getTokenOrThrow()

        const {
            page = 1,
            pageSize = 10,
            search,
            status
        } = options

        const params = {
            affiliateId,
            page,
            pageSize,
            subdomain: resolveSubdomain()
        }

        if (typeof search === 'string' && search.trim()) {
            params.search = search.trim()
        }

        if (typeof status === 'string' && status.trim()) {
            params.status = status.trim()
        }

        const response = await instance.get('/v1/auth/admin/verification-requests', {
            params,
            headers: {
                accept: '*/*',
                Authorization: `Bearer ${token}`
            }
        })

        return response
    }

    const ReviewVerificationRequest = async (verificationRequestId, approve, rejectionReason) => {
        const token = getTokenOrThrow()

        const payload = {
            approve: !!approve,
            rejectionReason: rejectionReason || null
        }

        const response = await instance.post(
            `/v1/auth/admin/verification-requests/${verificationRequestId}/review`,
            payload,
            {
                headers: {
                    accept: '*/*',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
        )

        return response
    }


    return (
        <AuthContext.Provider value={{     
                authStatus,
                Login,
                statusWizard,
                setStatusWizard,
                Register,
                GetInfoPerfil,
                setAuthStatus,
                UpdateWizardBool,
                UpdateCodigoAfiliado,
                AtualizarToken,
                GetMe,
                VerifAuth,
                setNewToken,
                newToken,
                verifiedUser,
                setVerifiedUser,
                RequestVerification,
                isAdmin,
                setIsAdmin,
                adminAccessMode,
                SetAdminAccessMode,
                ClearAdminAccessMode,
                GetPendingVerificationRequests,
                GetVerificationRequests,
                ReviewVerificationRequest
                
        }}>
            {children}
        </AuthContext.Provider>
    )
}


export const useAuth = () => {
    const context = useContext(AuthContext)

    if(!context) {
        throw new Error("Erro ao usar o AuthProvider")
    }

    return context;
}

export {AuthContext, AuthProvider}